import React from "react";

const PhoneDisplay = ({
  phone,
  className = "",
  showLabel = false,
  label = "Phone",
}) => {
  if (!phone) {
    return <span className={`text-gray-500 ${className}`}>N/A</span>;
  }

  // Format phone number for display
  const formatPhoneNumber = (phoneNumber) => {
    // Remove all non-digits
    const cleaned = phoneNumber.replace(/\D/g, "");

    // Format based on length
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
        6
      )}`;
    } else if (cleaned.length === 11 && cleaned.startsWith("1")) {
      return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(
        4,
        7
      )}-${cleaned.slice(7)}`;
    } else if (cleaned.length === 7) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    }

    // If it doesn't match common patterns, return as is
    return phoneNumber;
  };

  const formattedPhone = formatPhoneNumber(phone);

  return (
    <span className={`text-gray-700 ${className}`}>
      {showLabel && <span className="font-medium">{label}: </span>}
      {formattedPhone}
    </span>
  );
};

export default PhoneDisplay;
